import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/frontend/src/app/f/page.tsx");
